import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.string.anchor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _classCallCheck from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _inherits from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module widget/widget
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import MouseObserver from '@ckeditor/ckeditor5-engine/src/view/observer/mouseobserver';
import { getLabel, isWidget, WIDGET_SELECTED_CLASS_NAME } from "./utils";
import { getCode, keyCodes, parseKeystroke } from '@ckeditor/ckeditor5-utils/src/keyboard';
import env from '@ckeditor/ckeditor5-utils/src/env';
import "../theme/widget.css";
var selectAllKeystrokeCode = parseKeystroke('Ctrl+A');
/**
 * The widget plugin. It enables base support for widgets.
 *
 * See {@glink api/widget package page} for more details and documentation.
 *
 * This plugin enables multiple behaviors required by widgets:
 *
 * * The model to view selection converter for the editing pipeline (it handles widget custom selection rendering).
 * If a converted selection wraps around a widget element, that selection is marked as
 * {@link module:engine/view/selection~Selection#isFake fake}. Additionally, the `ck-widget_selected` CSS class
 * is added to indicate that widget has been selected.
 * * The mouse and keyboard events handling on and around widget elements.
 *
 * @extends module:core/plugin~Plugin
 */

var Widget = /*#__PURE__*/function (_Plugin) {
  _inherits(Widget, _Plugin);

  var _super = _createSuper(Widget);

  function Widget() {
    _classCallCheck(this, Widget);

    return _super.apply(this, arguments);
  }

  _createClass(Widget, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      var view = this.editor.editing.view;
      var viewDocument = view.document;
      /**
       * Holds previously selected widgets.
       *
       * @private
       * @type {Set.<module:engine/view/element~Element>}
       */

      this._previouslySelected = new Set(); // Model to view selection converter.
      // Converts selection placed over widget element to fake selection

      this.editor.editing.downcastDispatcher.on('selection', function (evt, data, conversionApi) {
        // Remove selected class from previously selected widgets.
        _this._clearPreviouslySelectedWidgets(conversionApi.writer);

        var viewWriter = conversionApi.writer;
        var viewSelection = viewWriter.document.selection;
        var selectedElement = viewSelection.getSelectedElement();
        var lastMarked = null;

        var _iterator = _createForOfIteratorHelper(viewSelection.getRanges()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var range = _step.value;

            var _iterator2 = _createForOfIteratorHelper(range),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var value = _step2.value;
                var node = value.item; // Do not mark nested widgets in selected one. See: #57.

                if (isWidget(node) && !isChild(node, lastMarked)) {
                  viewWriter.addClass(WIDGET_SELECTED_CLASS_NAME, node);

                  _this._previouslySelected.add(node);

                  lastMarked = node; // Check if widget is a single element selected.

                  if (node == selectedElement) {
                    viewWriter.setSelection(viewSelection.getRanges(), {
                      fake: true,
                      label: getLabel(selectedElement)
                    });
                  }
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }, {
        priority: 'low'
      }); // If mouse down is pressed on widget - create selection over whole widget.

      view.addObserver(MouseObserver);
      this.listenTo(viewDocument, 'mousedown', function () {
        return _this._onMousedown.apply(_this, arguments);
      }); // Handle custom keydown behaviour.

      this.listenTo(viewDocument, 'keydown', function () {
        return _this._onKeydown.apply(_this, arguments);
      }, {
        priority: 'high'
      }); // Handle custom delete behaviour.

      this.listenTo(viewDocument, 'delete', function (evt, data) {
        if (_this._handleDelete(data.direction == 'forward')) {
          data.preventDefault();
          evt.stop();
        }
      }, {
        priority: 'high'
      });
    }
    /**
     * Handles {@link module:engine/view/document~Document#event:mousedown mousedown} events on widget elements.
     *
     * @private
     * @param {module:utils/eventinfo~EventInfo} eventInfo
     * @param {module:engine/view/observer/domeventdata~DomEventData} domEventData
     */

  }, {
    key: "_onMousedown",
    value: function _onMousedown(eventInfo, domEventData) {
      var editor = this.editor;
      var view = editor.editing.view;
      var viewDocument = view.document;
      var element = domEventData.target; // Do nothing for single or double click inside nested editable.

      if (isInsideNestedEditable(element)) {
        // But at least triple click inside nested editable causes broken selection in Safari.
        // For such event, we select the entire nested editable element.
        // See: https://github.com/ckeditor/ckeditor5/issues/1463.
        if (env.isSafari && domEventData.domEvent.detail >= 3) {
          var mapper = editor.editing.mapper;

          var _modelElement = mapper.toModelElement(element);

          this.editor.model.change(function (writer) {
            domEventData.preventDefault();
            writer.setSelection(_modelElement, 'in');
          });
        }

        return;
      } // If target is not a widget element - check if one of the ancestors is.


      if (!isWidget(element)) {
        element = element.findAncestor(isWidget);

        if (!element) {
          return;
        }
      }

      domEventData.preventDefault(); // Focus editor if is not focused already.

      if (!viewDocument.isFocused) {
        view.focus();
      } // Create model selection over widget.


      var modelElement = editor.editing.mapper.toModelElement(element);

      this._setSelectionOverElement(modelElement);
    }
    /**
     * Handles {@link module:engine/view/document~Document#event:keydown keydown} events.
     *
     * @private
     * @param {module:utils/eventinfo~EventInfo} eventInfo
     * @param {module:engine/view/observer/domeventdata~DomEventData} domEventData
     */

  }, {
    key: "_onKeydown",
    value: function _onKeydown(eventInfo, domEventData) {
      var keyCode = domEventData.keyCode;
      var isLtrContent = this.editor.locale.contentLanguageDirection === 'ltr';
      var isForward = keyCode == keyCodes.arrowdown || keyCode == keyCodes[isLtrContent ? 'arrowright' : 'arrowleft'];
      var wasHandled = false; // Checks if the keys were handled and then prevents the default event behaviour and stops
      // the propagation.

      if (isArrowKeyCode(keyCode)) {
        wasHandled = this._handleArrowKeys(isForward);
      } else if (isSelectAllKeyCode(domEventData)) {
        wasHandled = this._selectAllNestedEditableContent() || this._selectAllContent();
      } else if (keyCode === keyCodes.enter) {
        wasHandled = this._handleEnterKey(domEventData.shiftKey);
      }

      if (wasHandled) {
        domEventData.preventDefault();
        eventInfo.stop();
      }
    }
    /**
     * Handles delete keys: backspace and delete.
     *
     * @private
     * @param {Boolean} isForward Set to true if delete was performed in forward direction.
     * @returns {Boolean|undefined} Returns `true` if keys were handled correctly.
     */

  }, {
    key: "_handleDelete",
    value: function _handleDelete(isForward) {
      var _this2 = this;

      // Do nothing when the read only mode is enabled.
      if (this.editor.isReadOnly) {
        return;
      }

      var modelDocument = this.editor.model.document;
      var modelSelection = modelDocument.selection; // Do nothing on non-collapsed selection.

      if (!modelSelection.isCollapsed) {
        return;
      }

      var objectElement = this._getObjectElementNextToSelection(isForward);

      if (objectElement) {
        this.editor.model.change(function (writer) {
          var previousNode = modelSelection.anchor.parent; // Remove previous element if empty.

          while (previousNode.isEmpty) {
            var nodeToRemove = previousNode;
            previousNode = nodeToRemove.parent;
            writer.remove(nodeToRemove);
          }

          _this2._setSelectionOverElement(objectElement);
        });
        return true;
      }
    }
    /**
     * Handles arrow keys.
     *
     * @private
     * @param {Boolean} isForward Set to true if arrow key should be handled in forward direction.
     * @returns {Boolean|undefined} Returns `true` if keys were handled correctly.
     */

  }, {
    key: "_handleArrowKeys",
    value: function _handleArrowKeys(isForward) {
      var model = this.editor.model;
      var schema = model.schema;
      var modelDocument = model.document;
      var modelSelection = modelDocument.selection;
      var objectElement = modelSelection.getSelectedElement(); // If object element is selected.

      if (objectElement && schema.isObject(objectElement)) {
        var position = isForward ? modelSelection.getLastPosition() : modelSelection.getFirstPosition();
        var newRange = schema.getNearestSelectionRange(position, isForward ? 'forward' : 'backward');

        if (newRange) {
          model.change(function (writer) {
            writer.setSelection(newRange);
          });
        }

        return true;
      } // If selection is next to object element.
      // Return if not collapsed.


      if (!modelSelection.isCollapsed) {
        return;
      }

      var objectElement2 = this._getObjectElementNextToSelection(isForward);

      if (!!objectElement2 && schema.isObject(objectElement2)) {
        this._setSelectionOverElement(objectElement2);

        return true;
      }
    }
    /**
     * Handles the enter key, giving users and access to positions in the editable directly before
     * (<kbd>Shift</kbd>+<kbd>Enter</kbd>) or after (<kbd>Enter</kbd>) the selected widget.
     * It improves the UX, mainly when the widget is the first or last child of the root editable
     * and there's no other way to type after or before it.
     *
     * @private
     * @param {Boolean} isBackwards Set to true if the new paragraph is to be inserted before
     * the selected widget (<kbd>Shift</kbd>+<kbd>Enter</kbd>).
     * @returns {Boolean|undefined} Returns `true` if keys were handled correctly.
     */

  }, {
    key: "_handleEnterKey",
    value: function _handleEnterKey(isBackwards) {
      var model = this.editor.model;
      var modelSelection = model.document.selection;
      var selectedElement = modelSelection.getSelectedElement();

      if (shouldInsertParagraph(selectedElement, model.schema)) {
        model.change(function (writer) {
          var position = writer.createPositionAt(selectedElement, isBackwards ? 'before' : 'after');
          var paragraph = writer.createElement('paragraph'); // Split the parent when inside a block element.
          // https://github.com/ckeditor/ckeditor5/issues/1529

          if (model.schema.isBlock(selectedElement.parent)) {
            var paragraphLimit = model.schema.findAllowedParent(position, paragraph);
            position = writer.split(position, paragraphLimit).position;
          }

          writer.insert(paragraph, position);
          writer.setSelection(paragraph, 'in');
        });
        return true;
      }
    }
    /**
     * Extends the {@link module:engine/model/selection~Selection document's selection} to span the entire
     * content of the nested editable if already anchored in one.
     *
     * See: {@link module:engine/model/schema~Schema#getLimitElement}.
     *
     * @private
     */

  }, {
    key: "_selectAllNestedEditableContent",
    value: function _selectAllNestedEditableContent() {
      var model = this.editor.model;
      var documentSelection = model.document.selection;
      var limitElement = model.schema.getLimitElement(documentSelection);

      if (documentSelection.getFirstRange().root == limitElement) {
        return false;
      }

      model.change(function (writer) {
        writer.setSelection(writer.createRangeIn(limitElement));
      });
      return true;
    }
    /**
     * Handles <kbd>CTRL + A</kbd> when widget is selected.
     *
     * @private
     * @returns {Boolean} Returns true if widget was selected and selecting all was handled by this method.
     */

  }, {
    key: "_selectAllContent",
    value: function _selectAllContent() {
      var model = this.editor.model;
      var editing = this.editor.editing;
      var view = editing.view;
      var viewDocument = view.document;
      var viewSelection = viewDocument.selection;
      var selectedElement = viewSelection.getSelectedElement(); // Only widget is selected.
      // https://github.com/ckeditor/ckeditor5-widget/issues/23

      if (selectedElement && isWidget(selectedElement)) {
        var widgetParent = editing.mapper.toModelElement(selectedElement.parent);
        model.change(function (writer) {
          writer.setSelection(writer.createRangeIn(widgetParent));
        });
        return true;
      }

      return false;
    }
    /**
     * Sets {@link module:engine/model/selection~Selection document's selection} over given element.
     *
     * @private
     * @param {module:engine/model/element~Element} element
     */

  }, {
    key: "_setSelectionOverElement",
    value: function _setSelectionOverElement(element) {
      this.editor.model.change(function (writer) {
        writer.setSelection(writer.createRangeOn(element));
      });
    }
    /**
     * Checks if {@link module:engine/model/element~Element element} placed next to the current
     * {@link module:engine/model/selection~Selection model selection} exists and is marked in
     * {@link module:engine/model/schema~Schema schema} as `object`.
     *
     * @private
     * @param {Boolean} forward Direction of checking.
     * @returns {module:engine/model/element~Element|null}
     */

  }, {
    key: "_getObjectElementNextToSelection",
    value: function _getObjectElementNextToSelection(forward) {
      var model = this.editor.model;
      var schema = model.schema;
      var modelSelection = model.document.selection; // Clone current selection to use it as a probe. We must leave default selection as it is so it can return
      // to its current state after undo.

      var probe = model.createSelection(modelSelection);
      model.modifySelection(probe, {
        direction: forward ? 'forward' : 'backward'
      });
      var objectElement = forward ? probe.focus.nodeBefore : probe.focus.nodeAfter;

      if (!!objectElement && schema.isObject(objectElement)) {
        return objectElement;
      }

      return null;
    }
    /**
     * Removes CSS class from previously selected widgets.
     *
     * @private
     * @param {module:engine/view/downcastwriter~DowncastWriter} writer
     */

  }, {
    key: "_clearPreviouslySelectedWidgets",
    value: function _clearPreviouslySelectedWidgets(writer) {
      var _iterator3 = _createForOfIteratorHelper(this._previouslySelected),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var widget = _step3.value;
          writer.removeClass(WIDGET_SELECTED_CLASS_NAME, widget);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      this._previouslySelected.clear();
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'Widget';
    }
  }]);

  return Widget;
}(Plugin); // Returns 'true' if provided key code represents one of the arrow keys.
//
// @param {Number} keyCode
// @returns {Boolean}


export { Widget as default };

function isArrowKeyCode(keyCode) {
  return keyCode == keyCodes.arrowright || keyCode == keyCodes.arrowleft || keyCode == keyCodes.arrowup || keyCode == keyCodes.arrowdown;
} // Returns 'true' if provided (DOM) key event data corresponds with the Ctrl+A keystroke.
//
// @param {module:engine/view/observer/keyobserver~KeyEventData} domEventData
// @returns {Boolean}


function isSelectAllKeyCode(domEventData) {
  return getCode(domEventData) == selectAllKeystrokeCode;
} // Returns `true` when element is a nested editable or is placed inside one.
//
// @param {module:engine/view/element~Element}
// @returns {Boolean}


function isInsideNestedEditable(element) {
  while (element) {
    if (element.is('editableElement') && !element.is('rootElement')) {
      return true;
    } // Click on nested widget should select it.


    if (isWidget(element)) {
      return false;
    }

    element = element.parent;
  }

  return false;
} // Checks whether the specified `element` is a child of the `parent` element.
//
// @param {module:engine/view/element~Element} element An element to check.
// @param {module:engine/view/element~Element|null} parent A parent for the element.
// @returns {Boolean}


function isChild(element, parent) {
  if (!parent) {
    return false;
  }

  return Array.from(element.getAncestors()).includes(parent);
} // Checks if enter key should insert paragraph. This should be done only on elements of type object (excluding inline objects).
//
// @param {module:engine/model/element~Element} element And element to check.
// @param {module:engine/model/schema~Schema} schema


function shouldInsertParagraph(element, schema) {
  return element && schema.isObject(element) && !schema.isInline(element);
}